import { IconRatingGood } from '@components/icons/rating-good';
import { IconRatingPoor } from '@components/icons/rating-poor';
import { IconRatingVeryGood } from '@components/icons/rating-very-good';
import { IconRatingVeryPoor } from '@components/icons/rating-very-poor';

export const getIconForRating = (rating, withColor = false) => {
  switch (rating) {
    case 'S':
      return <IconRatingVeryGood color={withColor ? 'green200' : 'purple100'} />;
    case 'Y':
      return <IconRatingGood color={withColor ? 'green100' : 'purple100'} />;
    case 'N':
      return <IconRatingPoor color={withColor ? 'red100' : 'purple100'} />;
    case 'D':
      return <IconRatingVeryPoor color={withColor ? 'red200' : 'purple100'} />;
    default:
      return null;
  }
};

export const getTextForRating = (rating) => {
  if (rating === 'S') return 'helpers.strongyes';
  if (rating === 'Y') return 'helpers.yes';
  if (rating === 'N') return 'helpers.no';
  if (rating === 'D') return 'helpers.defno';
  return '-';
};
